module.exports = {
      id: "breaking-news-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#breaking-news",
      toString: function () {
        return this.url;
      }
    }